export const BIBLE_DEFAULT_FONT = {
	fontVariant: "Inter",
	fontSize: 16,
};

export const BIBLE_SEARCH_MODE = {
	SIMPLE: "simple",
	ADVANCED: "advanced",
};

export const BIBLE_DESKTOP_SCREENS = {
	CHAPTER: "bible_chapter",
	SEARCH: "bible_search",
	ADVANCED_SEARCH: "bible_advanced_search",
	COMPARE: "bible_compare",
};

export const BIBLE_MOBILE_SCREENS = {
	CHAPTER: "bible_chapter",
	NAVIGATION: "bible_navigation",
	TRANSLATION: "bible_translation",
	COMPARE: "bible_compare",
	SEARCH: "bible_search",
	ADVANCED_SEARCH: "bible_advanced_search",
};

export const BIBLE_NAV_PANEL_SECTIONS = {
	SETTINGS_MENU: "SETTINGS_MENU",
	FONT_SETTINGS: "FONT_SETTINGS",
	BIBLE_HISTORY: "BIBLE_HISTORY",
	TRANSLATE_1: "TRANSLATE_1",
	TRANSLATE_2: "TRANSLATE_2",
};

// Names only; read them through utils/bible_book_names.ts, order is in utils/bible_book_order.ts.
export const BIBLE_BOOK_NAMES_DATA = {
	ru: {
		Gen: { name: "Бытие", short_name: "Быт" },
		Exo: { name: "Исход", short_name: "Исх" },
		Lev: { name: "Левит", short_name: "Лев" },
		Num: { name: "Числа", short_name: "Чис" },
		Deu: { name: "Второзаконие", short_name: "Втор" },
		Jos: { name: "Иисус Навин", short_name: "И.Нав" },
		Jdg: { name: "Книга Cудей", short_name: "Суд" },
		Rut: { name: "Руфь", short_name: "Руфь" },
		"1Sa": { name: "1 Царств", short_name: "1Цар" },
		"2Sa": { name: "2 Царств", short_name: "2Цар" },
		"1Ki": { name: "3 Царств", short_name: "3Цар" },
		"2Ki": { name: "4 Царств", short_name: "4Цар" },
		"1Ch": { name: "1 Паралипоменон", short_name: "1Пар" },
		"2Ch": { name: "2 Паралипоменон", short_name: "2Пар" },
		Ezr: { name: "Ездра", short_name: "Езд" },
		Neh: { name: "Неемия", short_name: "Неем" },
		Est: { name: "Есфирь", short_name: "Есф" },
		Job: { name: "Иов", short_name: "Иов" },
		Psa: {
			name: "Псалтирь",
			short_name: "Пс",
			secondName: "Псалом",
		},
		Pro: { name: "Притчи", short_name: "Притч" },
		Ecc: { name: "Екклесиаст", short_name: "Еккл" },
		Son: { name: "Песня песней", short_name: "Песн" },
		Isa: { name: "Исаия", short_name: "Ис" },
		Jer: { name: "Иеремия", short_name: "Иер" },
		Lam: { name: "Плач Иеремии", short_name: "Плач" },
		Eze: { name: "Иезекииль", short_name: "Иез" },
		Dan: { name: "Даниил", short_name: "Дан" },
		Hos: { name: "Осия", short_name: "Ос" },
		Joe: { name: "Иоиль", short_name: "Иоил" },
		Amo: { name: "Амос", short_name: "Амос" },
		Oba: { name: "Авдий", short_name: "Авд" },
		Jon: { name: "Иона", short_name: "Иона" },
		Mic: { name: "Михей", short_name: "Мих" },
		Nah: { name: "Наум", short_name: "Наум" },
		Hab: { name: "Аввакум", short_name: "Авв" },
		Zep: { name: "Софония", short_name: "Соф" },
		Hag: { name: "Аггей", short_name: "Агг" },
		Zec: { name: "Захария", short_name: "Зах" },
		Mal: { name: "Малахия", short_name: "Мал" },
		Mat: { name: "Матфея", short_name: "Мат" },
		Mar: { name: "Марка", short_name: "Мар" },
		Luk: { name: "Луки", short_name: "Лук" },
		Joh: { name: "Иоанна", short_name: "Ин" },
		Act: { name: "Деяния", short_name: "Деян" },
		Jam: { name: "Иакова", short_name: "Иак" },
		"1Pe": { name: "1 Петра", short_name: "1Петр" },
		"2Pe": { name: "2 Петра", short_name: "2Петр" },
		"1Jo": { name: "1 Иоанна", short_name: "1Иоан" },
		"2Jo": { name: "2 Иоанна", short_name: "2Иоан" },
		"3Jo": { name: "3 Иоанна", short_name: "3Иоан" },
		Jud: { name: "Иуда", short_name: "Иуд" },
		Rom: { name: "Римлянам", short_name: "Рим" },
		"1Co": { name: "1 Коринфянам", short_name: "1Кор" },
		"2Co": { name: "2 Коринфянам", short_name: "2Кор" },
		Gal: { name: "Галатам", short_name: "Гал" },
		Eph: { name: "Ефесянам", short_name: "Еф" },
		Phi: { name: "Филиппийцам", short_name: "Флп" },
		Col: { name: "Колоссянам", short_name: "Кол" },
		"1Th": { name: "1 Фессалоникийцам", short_name: "1Фес" },
		"2Th": { name: "2 Фессалоникийцам", short_name: "2Фес" },
		"1Ti": { name: "1 Тимофею", short_name: "1Тим" },
		"2Ti": { name: "2 Тимофею", short_name: "2Тим" },
		Tit: { name: "Титу", short_name: "Тит" },
		Phm: { name: "Филимону", short_name: "Флм" },
		Heb: { name: "Евреям", short_name: "Евр" },
		Rev: { name: "Откровение", short_name: "Откр" },
	},
	en: {
		Gen: { name: "Genesis", short_name: "Gen" },
		Exo: { name: "Exodus", short_name: "Exo" },
		Lev: { name: "Leviticus", short_name: "Lev" },
		Num: { name: "Numbers", short_name: "Num" },
		Deu: { name: "Deuteronomy", short_name: "Deu" },
		Jos: { name: "Joshua", short_name: "Josh" },
		Jdg: { name: "Judges", short_name: "Jdg" },
		Rut: { name: "Ruth", short_name: "Ruth" },
		"1Sa": { name: "1 Samuel", short_name: "1Sa" },
		"2Sa": { name: "2 Samuel", short_name: "2Sa" },
		"1Ki": { name: "1 Kings", short_name: "1Ki" },
		"2Ki": { name: "2 Kings", short_name: "2Ki" },
		"1Ch": { name: "1 Chronicles", short_name: "1Ch" },
		"2Ch": { name: "2 Chronicles", short_name: "2Ch" },
		Ezr: { name: "Ezra", short_name: "Ezr" },
		Neh: { name: "Nehemiah", short_name: "Neh" },
		Est: { name: "Esther", short_name: "Est" },
		Job: { name: "Job", short_name: "Job" },
		Psa: { name: "Psalms", short_name: "Ps", secondName: "Psalm" },
		Pro: { name: "Proverbs", short_name: "Prov" },
		Ecc: { name: "Ecclesiastes", short_name: "Ecc" },
		Son: { name: "Song of Solomon", short_name: "Song" },
		Isa: { name: "Isaiah", short_name: "Isa" },
		Jer: { name: "Jeremiah", short_name: "Jer" },
		Lam: { name: "Lamentations", short_name: "Lam" },
		Eze: { name: "Ezekiel", short_name: "Ezek" },
		Dan: { name: "Daniel", short_name: "Dan" },
		Hos: { name: "Hosea", short_name: "Hos" },
		Joe: { name: "Joel", short_name: "Joe" },
		Amo: { name: "Amos", short_name: "Amo" },
		Oba: { name: "Obadiah", short_name: "Oba" },
		Jon: { name: "Jonah", short_name: "Jon" },
		Mic: { name: "Micah", short_name: "Mic" },
		Nah: { name: "Nahum", short_name: "Nah" },
		Hab: { name: "Habakkuk", short_name: "Hab" },
		Zep: { name: "Zephaniah", short_name: "Zep" },
		Hag: { name: "Haggai", short_name: "Hag" },
		Zec: { name: "Zechariah", short_name: "Zec" },
		Mal: { name: "Malachi", short_name: "Mal" },
		Mat: { name: "Matthew", short_name: "Matt" },
		Mar: { name: "Mark", short_name: "Mark" },
		Luk: { name: "Luke", short_name: "Luke" },
		Joh: { name: "John", short_name: "John" },
		Act: { name: "Acts", short_name: "Acts" },
		Rom: { name: "Romans", short_name: "Rom" },
		"1Co": { name: "1 Corinthians", short_name: "1Co" },
		"2Co": { name: "2 Corinthians", short_name: "2Co" },
		Gal: { name: "Galatians", short_name: "Gal" },
		Eph: { name: "Ephesians", short_name: "Eph" },
		Phi: { name: "Philippians", short_name: "Phil" },
		Col: { name: "Colossians", short_name: "Col" },
		"1Th": { name: "1 Thessalonians", short_name: "1Th" },
		"2Th": { name: "2 Thessalonians", short_name: "2Th" },
		"1Ti": { name: "1 Timothy", short_name: "1Ti" },
		"2Ti": { name: "2 Timothy", short_name: "2Ti" },
		Tit: { name: "Titus", short_name: "Tit" },
		Phm: { name: "Philemon", short_name: "Phm" },
		Heb: { name: "Hebrews", short_name: "Heb" },
		Jam: { name: "James", short_name: "Jam" },
		"1Pe": { name: "1 Peter", short_name: "1Pe" },
		"2Pe": { name: "2 Peter", short_name: "2Pe" },
		"1Jo": { name: "1 John", short_name: "1Jo" },
		"2Jo": { name: "2 John", short_name: "2Jo" },
		"3Jo": { name: "3 John", short_name: "3Jo" },
		Jud: { name: "Jude", short_name: "Jud" },
		Rev: { name: "Revelation", short_name: "Rev" },
	},
	uk: {
		Gen: { name: "Буття", short_name: "Бут" },
		Exo: { name: "Вихід", short_name: "Вих" },
		Lev: { name: "Левит", short_name: "Лев" },
		Num: { name: "Числа", short_name: "Чис" },
		Deu: { name: "Повторення Закону", short_name: "Повт" },
		Jos: { name: "Iсус Навин", short_name: "Нав" },
		Jdg: { name: "Книга Суддiв", short_name: "Суд" },
		Rut: { name: "Рут", short_name: "Рут" },
		"1Sa": { name: "1-а Самуїлова", short_name: "1Сам" },
		"2Sa": { name: "2-а Самуїлова", short_name: "2Сам" },
		"1Ki": { name: "1-а царiв", short_name: "1Цар" },
		"2Ki": { name: "2-а царiв", short_name: "2Цар" },
		"1Ch": { name: "1-а хронiки", short_name: "1Хр" },
		"2Ch": { name: "2-а хронiки", short_name: "2Хр" },
		Ezr: { name: "Ездра", short_name: "Ез" },
		Neh: { name: "Неемія", short_name: "Неє" },
		Est: { name: "Естер", short_name: "Ест" },
		Job: { name: "Йов", short_name: "Йов" },
		Psa: {
			name: "Псалми",
			short_name: "Пс",
			secondName: "Псалом",
		},
		Pro: { name: "Приповiстi", short_name: "Прип" },
		Ecc: { name: "Екклезiяст", short_name: "Еккл" },
		Son: { name: "Пiсня над пiснями", short_name: "Пісн" },
		Isa: { name: "Iсая", short_name: "Іс" },
		Jer: { name: "Єремiя", short_name: "Єр" },
		Lam: { name: "Плач Єремiї", short_name: "Плач" },
		Eze: { name: "Єзекiїль", short_name: "Єзек" },
		Dan: { name: "Даниїл", short_name: "Дан" },
		Hos: { name: "Осiя", short_name: "Осі" },
		Joe: { name: "Йоїл", short_name: "Йоїл" },
		Amo: { name: "Амос", short_name: "Амос" },
		Oba: { name: "Овдiй", short_name: "Овд" },
		Jon: { name: "Йона", short_name: "Йона" },
		Mic: { name: "Михей", short_name: "Мих" },
		Nah: { name: "Наум", short_name: "Наум" },
		Hab: { name: "Авакум", short_name: "Авак" },
		Zep: { name: "Софонiя", short_name: "Соф" },
		Hag: { name: "Огiй", short_name: "Огій" },
		Zec: { name: "Захарiя", short_name: "Зах" },
		Mal: { name: "Малахiї", short_name: "Мал" },
		Mat: { name: "Вiд Матвiя", short_name: "Мат" },
		Mar: { name: "Вiд Марка", short_name: "Мар" },
		Luk: { name: "Вiд Луки", short_name: "Лук" },
		Joh: { name: "Вiд Iвана", short_name: "Ів" },
		Act: { name: "Дiї", short_name: "Дії" },
		Rom: { name: "До римлян", short_name: "Рим" },
		"1Co": { name: "1-е до коринтян", short_name: "1Кор" },
		"2Co": { name: "2-е до коринтян", short_name: "2Кор" },
		Gal: { name: "До галатiв", short_name: "Гал" },
		Eph: { name: "До ефесян", short_name: "Еф" },
		Phi: { name: "До филип'ян", short_name: "Флп" },
		Col: { name: "До колоссян", short_name: "Кол" },
		"1Th": { name: "1-е до солунян", short_name: "1Сол" },
		"2Th": { name: "2-е до солунян", short_name: "2Сол" },
		"1Ti": { name: "1-е Тимофiю", short_name: "1Тим" },
		"2Ti": { name: "2-е Тимофiю", short_name: "2Тим" },
		Tit: { name: "Титові", short_name: "Тит" },
		Phm: { name: "Филимону", short_name: "Флм" },
		Heb: { name: "До євреїв", short_name: "Євр" },
		Jam: { name: "Якова", short_name: "Як" },
		"1Pe": { name: "1-е Петра", short_name: "1Пет" },
		"2Pe": { name: "2-е Петра", short_name: "2Пет" },
		"1Jo": { name: "1-е Iвана", short_name: "1Ів" },
		"2Jo": { name: "2-е Iвана", short_name: "2Ів" },
		"3Jo": { name: "3-е Iвана", short_name: "3Ів" },
		Jud: { name: "Юда", short_name: "Юда" },
		Rev: { name: "Об'явлення", short_name: "Об" },
	},
};
